import * as React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { TAILLES_PAGE } from '@/hooks/usePagination';

/**
 * Barre de pagination commune, à poser sous un tableau ou une liste.
 * Se nourrit du résultat de `usePagination`:
 *   <BarrePagination pagination={pagination} nom="commandes" />
 * Ne s'affiche pas tant que la liste tient sur une seule page de 20 lignes.
 */
export function BarrePagination({ pagination, nom = 'lignes', className }) {
  const { page, nombrePages, taille, total, premiere, derniere, allerA, changerTaille } = pagination;
  const idTaille = React.useId();
  if (total <= TAILLES_PAGE[0]) return null;

  return (
    <nav
      aria-label={`Pagination des ${nom}`}
      className={cn(
        'mt-3 flex flex-wrap items-center justify-between gap-x-4 gap-y-2 rounded-xl border border-border bg-card px-3 py-2 text-sm',
        className,
      )}
    >
      <p className="min-w-0 text-muted-foreground" aria-live="polite">
        <span className="font-medium text-foreground">
          Page {page} sur {nombrePages}
        </span>
        {' · '}
        {taille} par page
        <span className="hidden md:inline">
          {' · '}
          {premiere} à {derniere} sur {total}
        </span>
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <label htmlFor={idTaille} className="sr-only">
          Nombre de {nom} par page
        </label>
        <select
          id={idTaille}
          value={taille}
          onChange={(event) => changerTaille(Number(event.target.value))}
          className="h-9 rounded-md border border-input bg-card px-2 text-sm focus:outline-none focus:ring-1 focus:ring-ring"
        >
          {TAILLES_PAGE.map((option) => (
            <option key={option} value={option}>
              {option} par page
            </option>
          ))}
        </select>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={page <= 1}
          onClick={() => allerA(page - 1)}
          aria-label="Page précédente"
        >
          <ChevronLeft aria-hidden="true" />
          Précédent
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={page >= nombrePages}
          onClick={() => allerA(page + 1)}
          aria-label="Page suivante"
        >
          Suivant
          <ChevronRight aria-hidden="true" />
        </Button>
      </div>
    </nav>
  );
}

export default BarrePagination;
